export const API_BASE = '/api';

export interface ApiError extends Error {
  code?: string;
  status?: number;
}

export const apiFetch = async <T>(path: string, init?: RequestInit): Promise<T> => {
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    headers: {
      'content-type': 'application/json',
      ...(init?.headers ?? {}),
    },
    ...init,
  });

  if (!response.ok) {
    let errorBody: { error?: string; code?: string } | null = null;
    try {
      errorBody = await response.json();
    } catch {
      errorBody = null;
    }
    const err = new Error(errorBody?.error || 'Request failed') as ApiError;
    err.code = errorBody?.code;
    err.status = response.status;
    throw err;
  }

  if (response.status === 204) {
    return null as T;
  }

  return response.json() as Promise<T>;
};
